<template>
  <div>
    <v-toolbar
      color="#2C004B"
      dark
      app
      clipped-left
      clipped-right
      flat
      height="40"
    >
      <v-toolbar-side-icon v-if="$route.name != 'Agenda'"
        @click="$router.push({ name: 'Agenda' })"
      >
        <v-icon>event</v-icon>
      </v-toolbar-side-icon>

      <v-toolbar-side-icon v-if="$route.name != 'Configuracao'"
        @click="$router.push({ name: 'Configuracao' })"
      >
        <v-icon dark>settings</v-icon>
      </v-toolbar-side-icon>

      <v-toolbar-title>
        <span>Agenda</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <span
        >{{ parametros.informacoesUsuario.login }} ({{ parametros.informacoesUsuario.nome }})</span
      >
      <v-toolbar-side-icon @click="toggleNavRight">
        <v-icon dark>filter_alt</v-icon>
      </v-toolbar-side-icon>
    </v-toolbar>
    <!--<VNavigationDrawer
      ref="drawerCustomLeft"
      app
      clipped
      left
      :width="widthDrawerLeft"
      :permanent="showDrawerCustomLeft"
      v-model="showDrawerCustomLeft"
    >
      <Calendar />
    </VNavigationDrawer>-->

    <VNavigationDrawer
      ref="drawerCustomRight"
      app
      clipped
      right
      :width="widthDrawerRight"
      v-model="showDrawerCustomRight"
      temporary
    >
      <div class="navRight">
        <PainelAuxiliarDireito v-on:hide-nav="toggleNavRight" />
      </div>
    </VNavigationDrawer>
  </div>
</template>

<script>
//import Calendar from "@/components/PainelCalendarioFiltros.vue";
import PainelAuxiliarDireito from "@/components/PainelAuxiliarDireito.vue";
import { mapState } from "vuex";

export default {
  components: { /*Calendar,*/ PainelAuxiliarDireito },
  data: () => ({
    drawer: false,
    //showDrawerCustomLeft: false,
    showDrawerCustomRight: false,
    //widthDrawerLeft: 280,
    widthDrawerRight: 280,
    borderDrawerCustom: "3px",
  }),
  methods: {
    toggleNavRight() {
      this.showDrawerCustomRight = !this.showDrawerCustomRight;
    },
    /*toggleNavLeft() {
      this.showDrawerCustomLeft = !this.showDrawerCustomLeft;
    },*/
    setDrawerStick(drawer) {
      let i = drawer.$el.querySelector(".v-navigation-drawer__border");
      i.style.width = this.borderDrawerCustom;
      i.style.cursor = "ew-resize";
      const el = drawer.$el;
      const drawerBorder = el.querySelector(".v-navigation-drawer__border");
      //const vm = this;
      //const isDrawerRight = el.classList.contains("v-navigation-drawer--right");
      function resize(/*e*/) {
        document.body.style.cursor = "ew-resize";
        /*let f = isDrawerRight
          ? document.body.scrollWidth - e.clientX
          : e.clientX;*/
        //el.style.width = f + "px";
      }

      drawerBorder.addEventListener(
        "mousedown",
        function () {
          el.style.transition = "initial";
          document.addEventListener("mousemove", resize, false);
        },
        false
      );

      document.addEventListener(
        "mouseup",
        function () {
          //el.style.transition = "";
          /*isDrawerRight
            ? (vm.widthDrawerRight = el.style.width)
            : (vm.widthDrawerLeft = el.style.width);*/
          document.body.style.cursor = "";
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
    },
  },
  mounted() {
    //this.setDrawerStick(this.$refs.drawerCustomLeft);
    this.setDrawerStick(this.$refs.drawerCustomRight);
  },
  computed: {
    ...mapState(["parametros"]),
  },
};
</script>

<style>
.navRight {
  overflow: hidden;
}
.menu {
  width: 300px;
  height: 400px;
  overflow-y: scroll;
}
</style>
